import { CityBreakTickets } from 'components/common/CityBreak/components/CityBreakBox/components/CityBreakTickets'
import Loader from 'components/shared/Loader'
import { useCityCart } from 'components/common/CityBreak/utils/useCityCart'
import { useEffect } from 'react'
import { CityBreakTicketsInCartProps } from './CityBreakTicketsInCart.types'
import { useIntl } from 'react-intl'
import { setIsErrorModalOpened } from 'store/general-slice'
import { useAppDispatch } from 'store/hooks'

export const CityBreakTicketsInCart = ({
    onCtaSuccess,
}: CityBreakTicketsInCartProps) => {
    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const {
        ticketsData,
        datesRange,
        daysNumber,
        deleteItemsFromCart,
        isDeleteLoading,
        isDeleteSuccess,
        isDeleteError,
    } = useCityCart()

    useEffect(() => {
        if (isDeleteSuccess && onCtaSuccess) onCtaSuccess()
    }, [isDeleteSuccess])

    useEffect(() => {
        // reset session in case of delete errors
        if (isDeleteError) dispatch(setIsErrorModalOpened(true))
    }, [isDeleteError])

    return ticketsData.length === 0 ? (
        <Loader />
    ) : (
        <CityBreakTickets
            title={formatMessage({
                id: 'promo.city_break.tickets_in_cart',
                defaultMessage: '_',
            })}
            datesRange={datesRange}
            tickets={ticketsData}
            daysNumber={daysNumber}
            hasPromoTickets
            onDelete={deleteItemsFromCart}
            isCtaLoading={isDeleteLoading}
            isCtaDisabled={isDeleteError}
        />
    )
}
